<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="排序" prop="sort">-->
            <!--                <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="短剧id" prop="videoId">-->
            <!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <template v-if="advanced">
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="是否跳转" prop="isJump">-->
              <!--                  <a-input v-model="queryParam.isJump" placeholder="请输入是否跳转" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="轮播图url" prop="bannerUsl">-->
              <!--                  <a-input v-model="queryParam.bannerUsl" placeholder="请输入轮播图url" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
                <!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />新增
        </a-button>
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['banner:banner:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />删除
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['banner:banner:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns" :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <!--        <img slot="bannerUsl" slot-scope="text, record" style="width: 48px;height: 48px;"  v-image-preview :src="record.bannerUsl">-->
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.bannerUsl" slot="bannerUsl"
          slot-scope="text, record">
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.bannerUslEn" slot="bannerUslEn"
          slot-scope="text, record">
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.bannerUslJa" slot="bannerUslJa"
          slot-scope="text, record">
        <video style="width: 100px;" :src="record.videoUrl" slot="videoUrl" slot-scope="text, record" controls></video>
        <video style="width: 100px;" :src="record.videoUrlEn" slot="videoUrlEn" slot-scope="text, record"
          controls></video>
        <video style="width: 100px;" :src="record.videoUrlJa" slot="videoUrlJa" slot-scope="text, record"
          controls></video>

        <span slot="isOpen" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isOpen == 1"
            @change="changeIsOpen($event, record)" />
        </span>


        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['banner:banner:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['banner:banner:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['banner:banner:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" :rowKey="(record, index) => index + 1" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBanner, listBanner, delBanner, changeIsOpen } from '@/api/banner/banner'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import Video from "@/views/video";

export default {
  name: 'Banner',
  components: {
    Video,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        sort: null,
        videoId: null,
        isJump: null,
        bannerUsl: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          // ellipsis: true,,
          width: '10%',
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'imgType',
          // ellipsis: true,,
          width: '15%',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 0) {
              return '轮播图'
            } else if (t == 1) {
              return '广告图'
            }
          }
        },
        {
          title: '所属',
          dataIndex: 'bannerType',
          // ellipsis: true,,
          width: '15%',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 0) {
              return 'APP'
            } else if (t == 1) {
              return 'PC'
            }
          }
        },
        {
          title: '跳转类型',
          dataIndex: 'type',
          // ellipsis: true,,
          width: '15%',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 0) {
              return '短剧'
            } else if (t == 1) {
              return '外部链接'
            } else if (t == 2) {
              return '充值页面'
            } else if (t == 3) {
              return '签到'
            }
            else if (t == 4) {
              return '会员充值页面'
            }
          }
        },
        {
          title: '是否启用',
          dataIndex: 'isOpen',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'isOpen' }
        },
        {
          title: '轮播图',
          dataIndex: 'bannerUsl',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'bannerUsl' }
        },
        {
          title: '英文轮播图',
          dataIndex: 'bannerUslEn',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'bannerUslEn' }
        },
        {
          title: '日语轮播图',
          dataIndex: 'bannerUslJa',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'bannerUslJa' }
        },
        {
          title: '视频',
          dataIndex: 'videoUrl',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'videoUrl' }
        },
        {
          title: '英文视频',
          dataIndex: 'videoUrlEn',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'videoUrlEn' }
        },
        {
          title: '日语视频',
          dataIndex: 'videoUrlJa',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'videoUrlJa' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          // ellipsis: true,,
          width: '30%',
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          ellipsis: true,
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询轮播图列表 */
    getList() {
      this.loading = true
      pageBanner(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen(e, record) {
      const newStatus = e ? 1 : 0

      if (newStatus === 0) {
        // 关闭时确认
        this.$confirm({
          title: '确认关闭',
          content: '确保轮播图有一个可用状态，是否继续？',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            record.isOpen = 0
            changeIsOpen({ id: record.id, isOpen: 0 }).then(() => {
              this.$message.success('已关闭')
            })
          },
          onCancel: () => {
            // 恢复原来的状态
            record.isOpen = 1
          }
        })
      } else {
        // 开启直接执行
        record.isOpen = 1
        changeIsOpen({ id: record.id, isOpen: 1 }).then(() => {
          this.$message.success('已开启')
        })
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        sort: undefined,
        videoId: undefined,
        isJump: undefined,
        bannerUsl: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ "id": id }))
          return delBanner(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('banner/banner/export', {
            ...that.queryParam
          }, `轮播图_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
